(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[989],{

/***/ 37476:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[profile]",
      function () {
        return __webpack_require__(30220);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _profile_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/shimmer.tsx
var shimmer = __webpack_require__(92042);
// EXTERNAL MODULE: ./src/layouts/home/index.tsx
var home = __webpack_require__(91511);
// EXTERNAL MODULE: ./src/components/icon/index.tsx + 39 modules
var icon = __webpack_require__(72287);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-circular-progressbar/dist/index.esm.js
var index_esm = __webpack_require__(95774);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 104 modules
var swiper_react = __webpack_require__(29453);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/graphql/queries/vendor.query.ts
var vendor_query = __webpack_require__(19057);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(44920);
// EXTERNAL MODULE: ./node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(92432);
// EXTERNAL MODULE: ./node_modules/next-urql/dist/next-urql.es.js + 1 modules
var next_urql_es = __webpack_require__(61325);
// EXTERNAL MODULE: ./src/graphql/mutations/vendor.mutation.ts
var vendor_mutation = __webpack_require__(46958);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(27643);
// EXTERNAL MODULE: ./src/components/spinner/index.tsx
var spinner = __webpack_require__(77429);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.module.js + 38 modules
var index_module = __webpack_require__(64909);
;// CONCATENATED MODULE: ./src/components/dialog/index.tsx







var RadixDialog = function(_param) /*#__PURE__*/ {
    var trigger = _param.trigger, title = _param.title, description = _param.description, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "trigger",
        "title",
        "description",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(index_module/* Root */.fC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Trigger */.xz, {
                className: "w-full focus:ring-0 focus-visible:ring-0 focus-within:outline-none active:ring-0",
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Portal */.h_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Overlay */.aV, {
                    className: "w-screen h-screen grid place-items-center bg-black/30 !z-[2147483646] fixed top-0 overlay-animate",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Content */.VY, {
                        className: "".concat(props.closeButtonTop ? "bg-transparent w-screen h-screen" : "bg-white w-[90%] max-w-[35rem]", " rounded-md p-6 border border-inawo-green/5 relative  overlay-content-animate"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Close */.x8, {
                                className: "".concat(props.closeButtonTop ? "fixed" : "absolute", " top-5 right-5 p-1.5 rounded-md transition bg-white z-[5] hover:bg-gray-200 cursor-pointer"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    iconName: "close"
                                })
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Title */.Dx, {
                                children: title
                            }),
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Description */.dk, {}),
                            children
                        ]
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var dialog = (RadixDialog);

// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(96245);
// EXTERNAL MODULE: ./src/components/button/index.tsx
var components_button = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/react-datetime-picker/dist/entry.nostyle.js
var entry_nostyle = __webpack_require__(20945);
// EXTERNAL MODULE: ./src/utils/auth.ts
var auth = __webpack_require__(62619);
;// CONCATENATED MODULE: ./src/modals/set-booking/index.tsx











var SetBooking = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(new Date()), 2), bookDate = ref[0], setBookDate = ref[1];
    var accessTokenDecoded = !!props.accessToken ? (0,jwt_decode_esm/* default */.Z)(props.accessToken) : null;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(vendor_mutation/* BookVendorService */.az), 2), bookVendorResult = ref1[0], bookVendorFn = ref1[1];
    var handleBooking = function() {
        if (!!props.accessToken) {
            dist/* default.success */.ZP.success(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "toast",
                children: [
                    "You have booked ",
                    props.serviceName
                ]
            }));
            props.setOpenModal(false);
            bookVendorFn({
                date: bookDate,
                vendorServiceId: props.id
            }).then(function(res) {
                var ref, ref1;
                if (((ref = res.error) === null || ref === void 0 ? void 0 : ref.message.includes("unauthenticated")) && !!(accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) && Date.now() >= (accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) * 1000) {
                    (0,auth/* refreshOnClientError */.WD)();
                } else if ((ref1 = res.error) === null || ref1 === void 0 ? void 0 : ref1.message) {
                    console.log("here ", res.error.message);
                    dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "toast",
                        children: [
                            "Couldn't book",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold",
                                children: props.serviceName
                            })
                        ]
                    }));
                }
            }).catch(function(err) {
                console.log(err);
                dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "toast",
                    children: [
                        "Couldn't book",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold",
                            children: props.serviceName
                        }),
                        " "
                    ]
                }));
            });
        } else {
            router.push("/login");
            dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "toast",
                children: "You need to be logged in to book a vendor"
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-xl md:text-2xl text-inawo-green line-clamp-1 w-full font-bold",
                children: "Book A Vendor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-full justify-start items-start gap-6 mt-6 md:mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-start items-start gap-0 w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "date",
                                className: "text-base font-sfpro text-inawo-grey-200",
                                children: "Pick a date"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(entry_nostyle/* default */.Z, {
                                value: bookDate,
                                name: "date",
                                minDate: new Date(),
                                onChange: setBookDate,
                                className: "border-0 border-b text-base py-3 pl-0 border-inawo-grey-300 w-full focus:ring-0 focus:border-inawo-green transition"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex justify-end items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                            handleClick: function() {
                                handleBooking();
                            },
                            loader: bookVendorResult.fetching,
                            disabled: bookVendorResult.fetching || bookDate === null,
                            type: "button",
                            label: "Book",
                            children: "Book"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var set_booking = (SetBooking);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/profile/[profile]/index.tsx























var SingleProfile = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var ref16 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), show = ref16[0], setShow = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), openModal = ref17[0], setOpenModal = ref17[1];
    var accessToken = (0,store/* default */.Z)(function(state) {
        return state.accessToken;
    });
    react.useEffect(function() {
        setShow(true);
    }, []);
    var router = (0,next_router.useRouter)();
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: vendor_query/* GetVendorServiceByID */.ot,
        pause: !props.profile,
        variables: {
            vendorServiceId: props.profile
        }
    }), 1), serviceResult = ref18[0];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: vendor_query/* GetMyVendorProfile */.T8,
        pause: !props.profile || !accessToken
    }), 1), vendorProfileResult = ref19[0];
    var ref20 = (0,_sliced_to_array/* default */.Z)(react.useState((ref = serviceResult.data) === null || ref === void 0 ? void 0 : ref.getVendorServiceByID.pinned), 2), pinState = ref20[0], setPinState = ref20[1];
    react.useEffect(function() {
        if (!serviceResult.fetching) {
            var ref;
            setPinState((ref = serviceResult.data) === null || ref === void 0 ? void 0 : ref.getVendorServiceByID.pinned);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        (ref1 = serviceResult.data) === null || ref1 === void 0 ? void 0 : ref1.getVendorServiceByID.booked,
        (ref2 = serviceResult.data) === null || ref2 === void 0 ? void 0 : ref2.getVendorServiceByID.pinned, 
    ]);
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(vendor_mutation/* PinVendorService */.a6), 2), pinFn = ref21[1];
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(vendor_mutation/* UnpinVendorService */.V4), 2), unPinFn = ref22[1];
    var _service_name, ref23, ref24;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Inawo Vendors | Profile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: "Inawo Vendors | Profile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Vendors Profile on Inawo Vendors"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: serviceResult.fetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-screen w-screen grid place-items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {})
                }) : ((ref3 = serviceResult.error) === null || ref3 === void 0 ? void 0 : ref3.message) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "An error occured"
                }) : !!((ref4 = serviceResult.data) === null || ref4 === void 0 ? void 0 : ref4.getVendorServiceByID) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full pt-8 flex justify-start items-center gap-2 text-inawo-black",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "p-1.5 bg-transparent transition hover:bg-gray-50 rounded-md",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                            iconName: "arrowLeft"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "uppercase tracking-widest font-light font-sfpro text-base xs:text-lg",
                                    children: "Service Profile"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-full mx-auto w-fit flex flex-col justify-center relative items-center gap-2 my-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "max-w-[250px] md:max-w-lg flex justify-center relative mx-auto items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "font-sfpro text-center text-inawo-green w-[12rem] md:w-80 text-xl md:text-4xl font-medium",
                                            children: (_service_name = (ref5 = serviceResult.data) === null || ref5 === void 0 ? void 0 : ref5.getVendorServiceByID.service_name) !== null && _service_name !== void 0 ? _service_name : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-8 md:w-12 absolute top-0 -right-8 md:-right-16",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CircularProgressbar */.Ip, {
                                                    value: serviceResult.data.getVendorServiceByID.rating ? serviceResult.data.getVendorServiceByID.rating * 20 : 0,
                                                    text: serviceResult.data.getVendorServiceByID.rating ? "".concat(serviceResult.data.getVendorServiceByID.rating) : "0",
                                                    styles: (0,index_esm/* buildStyles */.y3)({
                                                        textColor: "#273F3B",
                                                        pathColor: "#CBB915",
                                                        trailColor: "#DBDFF1",
                                                        textSize: "36px"
                                                    })
                                                }),
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "uppercase text-[10px] md:text-sm max-w-[250px] tracking-widest font-light text-center text-inawo-green",
                                    children: (ref23 = (ref7 = (ref6 = serviceResult.data) === null || ref6 === void 0 ? void 0 : ref6.getVendorServiceByID.category) === null || ref7 === void 0 ? void 0 : ref7.Name) !== null && ref23 !== void 0 ? ref23 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-light text-center max-w-sm md:max-w-md text-inawo-green text-sm md:text-lg",
                                    children: (ref24 = (ref8 = serviceResult.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.getVendorServiceByID) === null || ref9 === void 0 ? void 0 : ref9.description) !== null && ref24 !== void 0 ? ref24 : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-2 justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[10px] md:text-sm text-inawo-green font-medium",
                                            children: "Price starts from:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-inawo-green text-sm md:text-lg",
                                            children: [
                                                "N",
                                                (ref11 = (ref10 = serviceResult.data) === null || ref10 === void 0 ? void 0 : ref10.getVendorServiceByID.price.amount) === null || ref11 === void 0 ? void 0 : ref11.toLocaleString()
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-center items-center gap-4",
                            children: [
                                pinState ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        if (!!accessToken) {
                                            var ref;
                                            setPinState(false);
                                            dist/* default.success */.ZP.success(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "toast",
                                                children: "You unpinned this service"
                                            }));
                                            unPinFn({
                                                vendorServiceId: (ref = serviceResult.data) === null || ref === void 0 ? void 0 : ref.getVendorServiceByID.id
                                            }).catch(function() {
                                                var ref;
                                                setPinState(true);
                                                dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "toast",
                                                    children: [
                                                        "Couldn't unpin",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-bold",
                                                            children: (ref = serviceResult.data) === null || ref === void 0 ? void 0 : ref.getVendorServiceByID.service_name
                                                        }),
                                                        " ",
                                                        "service"
                                                    ]
                                                }));
                                            });
                                        } else {
                                            router.push("/login");
                                            dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "toast",
                                                children: "You need to be logged in to show interest"
                                            }));
                                        }
                                    },
                                    className: "transition hover:bg-gray-200 cursor-pointer rounded-md grid place-items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        iconName: "pinGreenActive"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        if (!!accessToken) {
                                            var ref;
                                            setPinState(true);
                                            dist/* default.success */.ZP.success(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "toast",
                                                children: "You pinned this service"
                                            }));
                                            pinFn({
                                                vendorServiceId: (ref = serviceResult.data) === null || ref === void 0 ? void 0 : ref.getVendorServiceByID.id
                                            }).catch(function() {
                                                var ref;
                                                setPinState(false);
                                                dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "toast",
                                                    children: [
                                                        "Couldn't pin",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-bold",
                                                            children: (ref = serviceResult.data) === null || ref === void 0 ? void 0 : ref.getVendorServiceByID.service_name
                                                        }),
                                                        " ",
                                                        "service"
                                                    ]
                                                }));
                                            });
                                        } else {
                                            router.push("/login");
                                            dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "toast",
                                                children: "You need to be logged in to show interest"
                                            }));
                                        }
                                    },
                                    className: "transition hover:bg-gray-200 active:bg-gray-300 cursor-pointer rounded-md grid place-items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        iconName: "pinGreen"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog, {
                                        open: openModal,
                                        onOpenChange: setOpenModal,
                                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: function() {
                                                return setOpenModal(true);
                                            },
                                            className: "w-full text-white bg-inawo-green active:bg-inawo-green px-6 py-2.5 shadow flex justify-center items-center rounded-[0.75rem] transition hover:bg-inawo-green/95 cursor-pointer disabled:cursor-not-allowed disabled:bg-inawo-grey-200",
                                            children: "Book"
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(set_booking, {
                                            setOpenModal: setOpenModal,
                                            serviceName: serviceResult.data.getVendorServiceByID.service_name,
                                            accessToken: accessToken,
                                            id: serviceResult.data.getVendorServiceByID.id
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    rel: "noreferrer noopener",
                                    href: "https://wa.me/".concat((ref13 = (ref12 = serviceResult.data) === null || ref12 === void 0 ? void 0 : ref12.getVendorServiceByID.phone_number) === null || ref13 === void 0 ? void 0 : ref13.replace(/[^0-9]/g, "")),
                                    className: "p-2.5 bg-transparent transition hover:bg-gray-200 active:bg-gray-300 rounded-md cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                        iconName: "whatsapp"
                                    })
                                })
                            ]
                        }),
                        serviceResult.data.getVendorServiceByID.vendors_id === ((ref14 = vendorProfileResult.data) === null || ref14 === void 0 ? void 0 : ref14.getMyVendorProfile.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full flex justify-center items-center my-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/become-a-vendor/add-a-service?serviceId=".concat(serviceResult.data.getVendorServiceByID.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-inawo-green text-sm md:text-base px-4 py-2 rounded-md transition hover:bg-gray-200 active:bg-gray-300 mx-auto",
                                    children: "+ Update your showcase"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-10 ",
                            children: show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                spaceBetween: 8,
                                className: "profile-swiper",
                                slidesPerView: 2.8,
                                // modules={[Scrollbar, A11y]}
                                // scrollbar={{ draggable: true }}
                                centerInsufficientSlides: true,
                                grabCursor: true,
                                breakpoints: {
                                    // when window width is >= 320px
                                    320: {
                                        slidesPerView: 2.8,
                                        spaceBetween: 8
                                    },
                                    // when window width is >= 480px
                                    480: {
                                        slidesPerView: 3.4,
                                        spaceBetween: 10
                                    },
                                    // when window width is >= 640px
                                    640: {
                                        slidesPerView: 3.8,
                                        spaceBetween: 15
                                    },
                                    789: {
                                        slidesPerView: 4.2,
                                        spaceBetween: 20
                                    },
                                    1280: {
                                        slidesPerView: 4.2,
                                        spaceBetween: 20
                                    },
                                    1440: {
                                        slidesPerView: 6.0,
                                        spaceBetween: 25
                                    },
                                    1840: {
                                        slidesPerView: 6.9,
                                        spaceBetween: 25
                                    },
                                    2200: {
                                        slidesPerView: 7.8,
                                        spaceBetween: 25
                                    }
                                },
                                children: (ref15 = serviceResult.data) === null || ref15 === void 0 ? void 0 : ref15.getVendorServiceByID.showcase.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog, {
                                            closeButtonTop: true,
                                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex bg-inawo-green rounded-[15px] overflow-hidden flex-col justify-start items-start gap-2 relative h-32 sm:h-48 md:h-64 my-2 md:my-4",
                                                children: (item === null || item === void 0 ? void 0 : item.media) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item === null || item === void 0 ? void 0 : item.media,
                                                    placeholder: "blur",
                                                    objectFit: "cover",
                                                    blurDataURL: (0,shimmer/* default */.ZP)(400, 400),
                                                    objectPosition: "center",
                                                    layout: "fill",
                                                    quality: 75,
                                                    sizes: "30vw",
                                                    alt: "service",
                                                    priority: true
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    iconName: "sample"
                                                })
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[90%] h-[90%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 fixed p-4 md:p-8",
                                                children: (item === null || item === void 0 ? void 0 : item.media) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item === null || item === void 0 ? void 0 : item.media,
                                                    placeholder: "blur",
                                                    objectFit: "contain",
                                                    blurDataURL: (0,shimmer/* default */.ZP)(400, 400),
                                                    objectPosition: "center",
                                                    layout: "fill",
                                                    quality: 90,
                                                    sizes: "90vw",
                                                    alt: "service modal",
                                                    priority: true
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                    iconName: "sample"
                                                })
                                            })
                                        })
                                    }, (0,v4/* default */.Z)());
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-36 sm:h-52 md:h-72"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
SingleProfile.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(home/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var _profile_ = ((0,next_urql_es/* withUrqlClient */.X)(function(_ssr) {
    return {
        url: "https://production.inawo.live/query",
        requestPolicy: "network-only",
        fetchOptions: function() {
            return {
                headers: {
                    "x-user-token": (0,storage/* getAccessCookie */.tN)() ? "".concat((0,storage/* getAccessCookie */.tN)()) : ""
                }
            };
        }
    };
}, {
    ssr: false
})(SingleProfile));


/***/ }),

/***/ 9337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77429);


var Button = function(param) {
    var children = param.children, type = param.type, label = param.label, handleClick = param.handleClick, disabled = param.disabled, loader = param.loader, _design = param.design, design = _design === void 0 ? "primary" : _design;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: handleClick,
        "aria-label": label,
        type: type,
        className: "".concat(design === "primary" && "w-full bg-inawo-green active:bg-inawo-green px-6 py-3 shadow flex justify-center items-center rounded-[0.75rem] transition hover:bg-inawo-green/95 disabled:cursor-not-allowed disabled:bg-inawo-grey-200", " ").concat(design === "secondary" && "w-full bg-inawo-red active:bg-inawo-red px-6 py-3 shadow flex justify-center items-center rounded-[0.75rem] transition hover:bg-inawo-red/95 disabled:cursor-not-allowed disabled:bg-inawo-grey-200"),
        disabled: disabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "text-white font-light text-base",
            children: loader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_spinner__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$, {}) : children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 41411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Stack; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25934);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72287);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18716);







var Stack = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var active = props.name.toLowerCase() === "home" ? router.pathname === "/" : router.pathname.includes(props.name.toLowerCase());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        passHref: true,
        href: props.link,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.a */ .E.a, {
            initial: {
                scale: 1
            },
            whileHover: {
                scale: 1.05
            },
            className: "flex flex-col justify-center items-center ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-9 w-9 flex justify-center items-center",
                    children: active ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        iconName: props.iconNameActive
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        iconName: props.iconNameInactive
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "font-sfpro text-xs xs:text-sm ".concat(active ? "text-inawo-grey-500 font-semibold" : "text-inawo-black font-light"),
                    children: props.name
                })
            ]
        })
    });
};
var Stacklist = [
    {
        name: "Home",
        link: "/",
        iconNameInactive: "home",
        iconNameActive: "homeActive"
    },
    {
        name: "Search",
        link: "/search",
        iconNameInactive: "search",
        iconNameActive: "searchActive"
    },
    {
        name: "Interests",
        link: "/interests",
        iconNameInactive: "interest",
        iconNameActive: "interestActive"
    },
    {
        name: "Vendors",
        link: "/vendors",
        iconNameInactive: "vendors",
        iconNameActive: "vendorsActive"
    }, 
];
var FloatingBarHome = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed bg-white w-full px-6 py-2 bottom-0 left-0 right-0 z-10 flex justify-center items-center gap-8 sm:gap-12",
        children: Stacklist.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Stack, {
                name: item.name,
                link: item.link,
                iconNameActive: item.iconNameActive,
                iconNameInactive: item.iconNameInactive
            }, (0,uuid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)());
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FloatingBarHome);


/***/ }),

/***/ 77429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Spinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        className: "w-8",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 80 80",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#34544F",
                d: "M10,40c0,0,0-0.4,0-1.1c0-0.3,0-0.8,0-1.3c0-0.3,0-0.5,0-0.8c0-0.3,0.1-0.6,0.1-0.9c0.1-0.6,0.1-1.4,0.2-2.1 c0.2-0.8,0.3-1.6,0.5-2.5c0.2-0.9,0.6-1.8,0.8-2.8c0.3-1,0.8-1.9,1.2-3c0.5-1,1.1-2,1.7-3.1c0.7-1,1.4-2.1,2.2-3.1 c1.6-2.1,3.7-3.9,6-5.6c2.3-1.7,5-3,7.9-4.1c0.7-0.2,1.5-0.4,2.2-0.7c0.7-0.3,1.5-0.3,2.3-0.5c0.8-0.2,1.5-0.3,2.3-0.4l1.2-0.1 l0.6-0.1l0.3,0l0.1,0l0.1,0l0,0c0.1,0-0.1,0,0.1,0c1.5,0,2.9-0.1,4.5,0.2c0.8,0.1,1.6,0.1,2.4,0.3c0.8,0.2,1.5,0.3,2.3,0.5 c3,0.8,5.9,2,8.5,3.6c2.6,1.6,4.9,3.4,6.8,5.4c1,1,1.8,2.1,2.7,3.1c0.8,1.1,1.5,2.1,2.1,3.2c0.6,1.1,1.2,2.1,1.6,3.1 c0.4,1,0.9,2,1.2,3c0.3,1,0.6,1.9,0.8,2.7c0.2,0.9,0.3,1.6,0.5,2.4c0.1,0.4,0.1,0.7,0.2,1c0,0.3,0.1,0.6,0.1,0.9 c0.1,0.6,0.1,1,0.1,1.4C74,39.6,74,40,74,40c0.2,2.2-1.5,4.1-3.7,4.3s-4.1-1.5-4.3-3.7c0-0.1,0-0.2,0-0.3l0-0.4c0,0,0-0.3,0-0.9 c0-0.3,0-0.7,0-1.1c0-0.2,0-0.5,0-0.7c0-0.2-0.1-0.5-0.1-0.8c-0.1-0.6-0.1-1.2-0.2-1.9c-0.1-0.7-0.3-1.4-0.4-2.2 c-0.2-0.8-0.5-1.6-0.7-2.4c-0.3-0.8-0.7-1.7-1.1-2.6c-0.5-0.9-0.9-1.8-1.5-2.7c-0.6-0.9-1.2-1.8-1.9-2.7c-1.4-1.8-3.2-3.4-5.2-4.9 c-2-1.5-4.4-2.7-6.9-3.6c-0.6-0.2-1.3-0.4-1.9-0.6c-0.7-0.2-1.3-0.3-1.9-0.4c-1.2-0.3-2.8-0.4-4.2-0.5l-2,0c-0.7,0-1.4,0.1-2.1,0.1 c-0.7,0.1-1.4,0.1-2,0.3c-0.7,0.1-1.3,0.3-2,0.4c-2.6,0.7-5.2,1.7-7.5,3.1c-2.2,1.4-4.3,2.9-6,4.7c-0.9,0.8-1.6,1.8-2.4,2.7 c-0.7,0.9-1.3,1.9-1.9,2.8c-0.5,1-1,1.9-1.4,2.8c-0.4,0.9-0.8,1.8-1,2.6c-0.3,0.9-0.5,1.6-0.7,2.4c-0.2,0.7-0.3,1.4-0.4,2.1 c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.3-0.1,0.6-0.1,0.8c0,0.5-0.1,0.9-0.1,1.3C10,39.6,10,40,10,40z",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                    attributeType: "xml",
                    attributeName: "transform",
                    type: "rotate",
                    from: "0 40 40",
                    to: "360 40 40",
                    dur: "0.8s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#000",
                d: "M62,40.1c0,0,0,0.2-0.1,0.7c0,0.2,0,0.5-0.1,0.8c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.4-0.1,0.7 c-0.1,0.5-0.2,1-0.3,1.6c-0.2,0.5-0.3,1.1-0.5,1.8c-0.2,0.6-0.5,1.3-0.7,1.9c-0.3,0.7-0.7,1.3-1,2.1c-0.4,0.7-0.9,1.4-1.4,2.1 c-0.5,0.7-1.1,1.4-1.7,2c-1.2,1.3-2.7,2.5-4.4,3.6c-1.7,1-3.6,1.8-5.5,2.4c-2,0.5-4,0.7-6.2,0.7c-1.9-0.1-4.1-0.4-6-1.1 c-1.9-0.7-3.7-1.5-5.2-2.6c-1.5-1.1-2.9-2.3-4-3.7c-0.6-0.6-1-1.4-1.5-2c-0.4-0.7-0.8-1.4-1.2-2c-0.3-0.7-0.6-1.3-0.8-2 c-0.2-0.6-0.4-1.2-0.6-1.8c-0.1-0.6-0.3-1.1-0.4-1.6c-0.1-0.5-0.1-1-0.2-1.4c-0.1-0.9-0.1-1.5-0.1-2c0-0.5,0-0.7,0-0.7 s0,0.2,0.1,0.7c0.1,0.5,0,1.1,0.2,2c0.1,0.4,0.2,0.9,0.3,1.4c0.1,0.5,0.3,1,0.5,1.6c0.2,0.6,0.4,1.1,0.7,1.8 c0.3,0.6,0.6,1.2,0.9,1.9c0.4,0.6,0.8,1.3,1.2,1.9c0.5,0.6,1,1.3,1.6,1.8c1.1,1.2,2.5,2.3,4,3.2c1.5,0.9,3.2,1.6,5,2.1 c1.8,0.5,3.6,0.6,5.6,0.6c1.8-0.1,3.7-0.4,5.4-1c1.7-0.6,3.3-1.4,4.7-2.4c1.4-1,2.6-2.1,3.6-3.3c0.5-0.6,0.9-1.2,1.3-1.8 c0.4-0.6,0.7-1.2,1-1.8c0.3-0.6,0.6-1.2,0.8-1.8c0.2-0.6,0.4-1.1,0.5-1.7c0.1-0.5,0.2-1,0.3-1.5c0.1-0.4,0.1-0.8,0.1-1.2 c0-0.2,0-0.4,0.1-0.5c0-0.2,0-0.4,0-0.5c0-0.3,0-0.6,0-0.8c0-0.5,0-0.7,0-0.7c0-1.1,0.9-2,2-2s2,0.9,2,2C62,40,62,40.1,62,40.1z",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                    attributeType: "xml",
                    attributeName: "transform",
                    type: "rotate",
                    from: "0 40 40",
                    to: "-360 40 40",
                    dur: "0.6s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};



/***/ }),

/***/ 46958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qe": function() { return /* binding */ CreateMyVendorService; },
/* harmony export */   "V4": function() { return /* binding */ UnpinVendorService; },
/* harmony export */   "XB": function() { return /* binding */ CancelVendorServiceBookings; },
/* harmony export */   "a6": function() { return /* binding */ PinVendorService; },
/* harmony export */   "az": function() { return /* binding */ BookVendorService; },
/* harmony export */   "ge": function() { return /* binding */ CreateMyVendorServiceShowcases; },
/* harmony export */   "nB": function() { return /* binding */ CreateMyVendorProfile; }
/* harmony export */ });
/* unused harmony exports RateVendorService, DeleteMyVendorService, CreateMyVendorServiceShowcase, DeleteMyVendorServiceShowcase */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26997);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation PinVendorService($vendorServiceId: UUID!) {\n    pinVendorService(vendorServiceId: $vendorServiceId)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UnPinVendorService($vendorServiceId: UUID!) {\n    unPinVendorService(vendorServiceId: $vendorServiceId)\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation BookVendorService(\n    $vendorServiceId: UUID!\n    $date: Time!\n    $eventUuid: UUID\n  ) {\n    bookVendorService(\n      vendorServiceId: $vendorServiceId\n      date: $date\n      eventUUID: $eventUuid\n    )\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation RateVendorService(\n    $vendorServiceId: UUID!\n    $rating: Int!\n    $comment: String!\n    $bookingId: UUID!\n  ) {\n    rateVendorService(\n      vendorServiceId: $vendorServiceId\n      rating: $rating\n      comment: $comment\n      bookingId: $bookingId\n    ) {\n      id\n      vendors_id\n      vendor_service_id\n      vendor_bookings_id\n      comment\n      rating\n      user_uuid\n      event_uuid\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateMyVendorService($req: CreateMyVendorServiceReq!) {\n    createMyVendorService(req: $req) {\n      id\n      service_name\n      vendors_id\n      vendor_service_category_id\n      category {\n        id\n        Name\n      }\n      email\n      phone_number\n      description\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateMyVendorProfile($req: CreateMyVendorProfileReq!) {\n    createMyVendorProfile(req: $req) {\n      id\n      user_uuid\n      brand_name\n      description\n      phone_number\n      email\n      address\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CancelVendorServiceBookings($bookingId: UUID!) {\n    cancelVendorServiceBookings(bookingId: $bookingId)\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteMyVendorService($vendorServiceId: UUID!) {\n    deleteMyVendorService(vendorServiceId: $vendorServiceId)\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateMyVendorServiceShowcase($req: CreateMyVendorServiceShowcase!) {\n    createMyVendorServiceShowcase(req: $req) {\n      id\n      vendors_id\n      vendor_service_category_id\n      vendor_service_id\n      name\n      media\n      description\n      tags\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteMyVendorServiceShowcase(\n    $serviceId: UUID!\n    $showcaseId: UUID!\n  ) {\n    deleteMyVendorServiceShowcase(\n      serviceId: $serviceId\n      showcaseId: $showcaseId\n    )\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateMyVendorServiceShowcases(\n    $serviceId: UUID!\n    $req: [CreateMyVendorServiceShowcase!]!\n  ) {\n    createMyVendorServiceShowcases(serviceId: $serviceId, req: $req)\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var PinVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UnpinVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var BookVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var RateVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var CreateMyVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var CreateMyVendorProfile = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
var CancelVendorServiceBookings = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
var DeleteMyVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());
var CreateMyVendorServiceShowcase = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8());
var DeleteMyVendorServiceShowcase = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject9());
var CreateMyVendorServiceShowcases = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject10());


/***/ }),

/***/ 19057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T8": function() { return /* binding */ GetMyVendorProfile; },
/* harmony export */   "XP": function() { return /* binding */ GetPinnedVendorServices2; },
/* harmony export */   "ot": function() { return /* binding */ GetVendorServiceByID; },
/* harmony export */   "w3": function() { return /* binding */ GetVendorServiceBySearch; },
/* harmony export */   "yG": function() { return /* binding */ GetMyVendorBooking; }
/* harmony export */ });
/* unused harmony exports GetVendorServiceRandom, GetVendorServiceByVendor, GetMyVendorsServices, GetPinnedVendorServices */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26997);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceRandom($page: Int, $pageSize: Int) {\n    getVendorServiceRandom {\n      id\n      interests\n      vendors_id\n      vendor_service_category_id\n      service_name\n      pinned\n      description\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        media\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceByVendor(\n    $vendorsId: UUID!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceByVendor(vendorsId: $vendorsId) {\n      id\n      interests\n      vendors_id\n      vendor_service_category_id\n      service_name\n      pinned\n      description\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        media\n      }\n      phone_number\n      email\n      address\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetMyVendorServices($page: Int, $pageSize: Int) {\n    getMyVendorServices {\n      id\n      interests\n      vendors_id\n      vendor_service_category_id\n      service_name\n      price {\n        currency\n        amount\n      }\n      pinned\n      description\n      phone_number\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        name\n        media\n        description\n        tags\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetPinnedVendorServices($page: Int, $pageSize: Int) {\n    getPinnedVendorServices {\n      id\n      interests\n      vendor_service_category_id\n      vendors_id\n      service_name\n      pinned\n      description\n      category {\n        id\n        Name\n      }\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        name\n        media\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceBySearch(\n    $searchTerm: String!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceBySearch(searchTerm: $searchTerm) {\n      id\n      interests\n      vendors_id\n      price {\n        currency\n        amount\n      }\n      rating\n      vendor_service_category_id\n      category {\n        Name\n        id\n      }\n      service_name\n      pinned\n      booked\n      description\n      phone_number\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        media\n      }\n      created_at\n      updated_at\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetMyVendorProfile($page: Int, $pageSize: Int) {\n    getMyVendorProfile {\n      id\n      user_uuid\n      brand_name\n      description\n      logo\n      phone_number\n      email\n      address\n      created_at\n      updated_at\n      services {\n        id\n        interests\n        vendor_service_category_id\n        vendors_id\n        category {\n          Name\n          id\n        }\n        service_name\n        showcase(page: $page, pageSize: $pageSize) {\n          id\n          media\n          vendor_service_id\n          vendor_service_category_id\n          vendors_id\n        }\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceByID(\n    $vendorServiceId: UUID!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceByID(vendorServiceId: $vendorServiceId) {\n      id\n      interests\n      vendors_id\n      price {\n        currency\n        amount\n      }\n      vendor_service_category_id\n      category {\n        id\n        Name\n      }\n      service_name\n      pinned\n      description\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        media\n      }\n      phone_number\n      booked\n      rating\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetMyVendorBooking($page: Int, $pageSize: Int) {\n    getMyVendorBooking {\n      vendor_Service {\n        id\n        interests\n        vendors_id\n        price {\n          currency\n          amount\n        }\n        rating\n        vendor_service_category_id\n        category {\n          id\n          Name\n        }\n        service_name\n        pinned\n        booked\n        description\n        phone_number\n        email\n        address\n        showcase(page: $page, pageSize: $pageSize) {\n          id\n          vendors_id\n          vendor_service_category_id\n          vendor_service_id\n          name\n          media\n        }\n      }\n      id\n      user_uuid\n      event_uuid\n      vendors_id\n      vendor_service_id\n      booking_status\n      date\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetPinnedVendorServices2($page: Int, $pageSize: Int) {\n    getPinnedVendorServices2 {\n      id\n      name\n      description\n      services {\n        id\n        service_name\n        interests\n        vendors_id\n        price {\n          currency\n          amount\n        }\n        rating\n        category {\n          id\n          Name\n        }\n        pinned\n        booked\n        showcase(page: $page, pageSize: $pageSize) {\n          id\n          vendors_id\n          vendor_service_id\n          vendor_service_category_id\n          media\n        }\n      }\n      images\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var GetVendorServiceRandom = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var GetVendorServiceByVendor = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var GetMyVendorsServices = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var GetPinnedVendorServices = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var GetVendorServiceBySearch = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var GetMyVendorProfile = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
var GetVendorServiceByID = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
var GetMyVendorBooking = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());
var GetPinnedVendorServices2 = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8());


/***/ }),

/***/ 91511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_floating_bar_home__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41411);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44920);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86501);






var HomeLayout = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), show = ref[0], setShow = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setShow(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hot_toast__WEBPACK_IMPORTED_MODULE_4__/* .Toaster */ .x7, {
                position: "bottom-center",
                reverseOrder: true,
                containerStyle: {
                    zIndex: "2147483647",
                    isolation: "isolate",
                    transformStyle: "preserve-3d",
                    transform: "translateZ(1000px)",
                    bottom: 90
                },
                toastOptions: {
                    duration: 2000,
                    success: {
                        style: {
                            background: "#376C65",
                            border: "0.5px dashed #376C65",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "20px 50px",
                            fontFamily: "SF Pro Text",
                            fontStyle: "normal",
                            fontWeight: "600",
                            fontSize: "12px",
                            textAlign: "center",
                            color: "#fff",
                            borderRadius: "15px",
                            zIndex: "2147483647",
                            isolation: "isolate",
                            transformStyle: "preserve-3d",
                            transform: "trasnslateZ(1000px)"
                        }
                    },
                    error: {
                        style: {
                            background: "#6C3737",
                            border: "0.5px dashed #6C3737",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "12px 8px",
                            fontFamily: "SF Pro Text",
                            fontStyle: "normal",
                            fontWeight: "400",
                            fontSize: "12px",
                            lineHeight: "19px",
                            textAlign: "center",
                            color: "#fff",
                            borderRadius: "15px",
                            zIndex: "2147483647",
                            isolation: "isolate",
                            transformStyle: "preserve-3d",
                            transform: "trasnslateZ(1000px)"
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "z-[0] w-full relative overflow-x-hidden bg-white",
                children: [
                    show && (0,_utils_storage__WEBPACK_IMPORTED_MODULE_3__/* .hasAccessCookie */ .rh)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_floating_bar_home__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-[-1] bg-inawo-bg-green-top-bg w-screen fixed top-0 h-1/3"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-[1300px] mx-auto z-[3] pb-24 px-4 md:px-8 flex flex-col justify-start min-h-full items-center gap-1",
                        children: props.children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-[-1] bg-inawo-bg-grey-bottom-bottom-bg w-screen fixed bottom-0 h-1/5"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeLayout);


/***/ }),

/***/ 27643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(44920);
;// CONCATENATED MODULE: ./src/store/auth/index.ts

var refreshCookie = (0,storage/* getRefreshCookie */.Qy)();
var accessCookie = (0,storage/* getAccessCookie */.tN)();
var createAuthSlice = function(set) {
    return {
        accessToken: accessCookie ? accessCookie : "",
        setAccessToken: function(arg, ctx) {
            set(function() {
                return {
                    accessToken: arg
                };
            });
            if (ctx) {
                (0,storage/* setAccessCookie */.AA)(arg, ctx);
            } else {
                (0,storage/* setAccessCookie */.AA)(arg);
            }
        },
        refreshToken: refreshCookie ? refreshCookie : "",
        setRefreshToken: function(arg, ctx) {
            set(function() {
                return {
                    refreshToken: arg
                };
            });
            if (ctx) {
                (0,storage/* setRefreshCookie */.gE)(arg, ctx);
            } else {
                (0,storage/* setRefreshCookie */.gE)(arg);
            }
        }
    };
};
/* harmony default export */ var auth = (createAuthSlice);

;// CONCATENATED MODULE: ./src/store/index.ts



// import { immer } from "zustand/middleware/immer";

var useStore = (0,esm/* default */.ZP)()(function() {
    for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
        a[_key] = arguments[_key];
    }
    return (0,_object_spread/* default */.Z)({}, auth.apply(void 0, (0,_to_consumable_array/* default */.Z)(a)));
});
// const useStore = create<StoreType>()(
//   immer((...a) => ({
//     ...createAuthSlice(...a),
//   }))
// );
/* harmony default export */ var store = (useStore);


/***/ }),

/***/ 62619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WD": function() { return /* binding */ refreshOnClientError; }
/* harmony export */ });
/* unused harmony exports getAuthClient, addAuthToOperationClient, willAuthErrorClient, didAuthErrorClient, onErrorClient */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94301);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44920);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86501);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96245);









var refreshOnClientError = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var errorOut, ref, resultInitial, result, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    errorOut = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                    ;
                    _ctx.next = 4;
                    return isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default()("https://production.inawo.live/query", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            query: "\n							query Refresh($refresh_token: String!) {\n								refresh(refresh_token: $refresh_token) {\n									refresh_token\n									access_token\n									access_expiry\n								}\n							}\n					",
                            variables: {
                                refresh_token: (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)() ? (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)() : ""
                            }
                        })
                    });
                case 4:
                    resultInitial = _ctx.sent;
                    _ctx.next = 7;
                    return resultInitial.json();
                case 7:
                    result = _ctx.sent;
                    if ((ref = result.data) === null || ref === void 0 ? void 0 : ref.refresh) {
                        // save the new tokens in storage for next restart
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setRefreshCookie */ .gE)(result.data.refresh.refresh_token);
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setAccessCookie */ .AA)(result.data.refresh.access_token);
                        react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Please refresh your browser window.");
                    } else {
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteAccessCookie */ .i)();
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteRefreshCookie */ .V6)();
                        errorOut && react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Your session has expired. Please login afresh.");
                    }
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshOnClientError() {
        return _ref.apply(this, arguments);
    };
}();
// still a work in progress, need to find a way to pass in req and res from context
var getAuthClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var authState, ref, accessToken, refreshToken, resultInitial, result;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    authState = param.authState;
                    ;
                    if (authState) {
                        _ctx.next = 8;
                        break;
                    }
                    accessToken = (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getAccessCookie */ .tN)();
                    refreshToken = (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)();
                    if (!accessToken) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        accessToken: accessToken,
                        refreshToken: refreshToken
                    });
                case 7:
                    return _ctx.abrupt("return", null);
                case 8:
                    _ctx.next = 10;
                    return isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default()("https://production.inawo.live/query", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            query: "\n										query Refresh($refresh_token: String!) {\n								refresh(refresh_token: $refresh_token) {\n									refresh_token\n									access_token\n									access_expiry\n								}\n							}\n					",
                            variables: {
                                refresh_token: authState.refreshToken
                            }
                        })
                    });
                case 10:
                    resultInitial = _ctx.sent;
                    _ctx.next = 13;
                    return resultInitial.json();
                case 13:
                    result = _ctx.sent;
                    if (!((ref = result.data) === null || ref === void 0 ? void 0 : ref.refresh)) {
                        _ctx.next = 20;
                        break;
                    }
                    // save the new tokens in storage for next restart
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setRefreshCookie */ .gE)(result.data.refresh.refresh_token);
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setAccessCookie */ .AA)(result.data.refresh.access_token);
                    return _ctx.abrupt("return", {
                        accessToken: result.data.refresh.access_token,
                        refreshToken: result.data.refresh.refresh_token
                    });
                case 20:
                    // otherwise, if refresh fails, log clear storage and log out
                    console.log("Vendors RefreshQuery Home page Error :>> ", result);
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteAccessCookie */ .i)();
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteRefreshCookie */ .V6)();
                    // your app logout logic should trigger here
                    react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Please refresh your browser window.");
                    return _ctx.abrupt("return", null);
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAuthClient(_) {
        return _ref.apply(this, arguments);
    };
}();
var addAuthToOperationClient = function(param) {
    var authState = param.authState, operation = param.operation;
    // the token isn't in the auth state, return the operation without changes
    if (!authState || !authState.accessToken) {
        return operation;
    }
    // fetchOptions can be a function (See Client API) but you can simplify this based on usage
    var fetchOptions = typeof operation.context.fetchOptions === "function" ? operation.context.fetchOptions() : operation.context.fetchOptions || {};
    return makeOperation(operation.kind, operation, _object_spread_props(_object_spread({}, operation.context), {
        requestPolicy: "network-only",
        fetchOptions: _object_spread_props(_object_spread({}, fetchOptions), {
            headers: _object_spread_props(_object_spread({}, fetchOptions.headers), {
                "x-user-token": authState.accessToken ? "".concat(authState.accessToken) : ""
            })
        })
    }));
};
var willAuthErrorClient = function(param) {
    var authState = param.authState;
    //if there's no authState the trigger the auth arror
    if (!authState) return true;
    // e.g. check for expiration, existence of auth etc
    var accessTokenDecoded = jwt_decode(authState.accessToken);
    var refreshTokenDecoded = jwt_decode(authState.refreshToken);
    // if access token will almost expire
    if (!!(accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) && Date.now() >= (accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) * 1000 - 5000) {
        return true;
    }
    // if refresh token will almost expire
    if (!!(refreshTokenDecoded === null || refreshTokenDecoded === void 0 ? void 0 : refreshTokenDecoded.exp) && Date.now() >= (refreshTokenDecoded === null || refreshTokenDecoded === void 0 ? void 0 : refreshTokenDecoded.exp) * 1000 - 5000) {
        return true;
    }
    return false;
};
var didAuthErrorClient = function(param) {
    var error = param.error;
    return error.graphQLErrors.some(function(e) {
        return e.message.includes("unauthenticated");
    });
};
var onErrorClient = function(param, _operation) {
    var graphQLErrors = param.graphQLErrors, networkError = param.networkError;
    if (graphQLErrors) {
        if (graphQLErrors.some(function(param) {
            var message = param.message;
            return message.includes("unauthenticated");
        })) {
            toast.error("Your session has expired.");
        }
    }
    if (networkError) console.log("[Network error]: ".concat(networkError));
};


/***/ }),

/***/ 92042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports shimmer, toBase64 */
var shimmer = function(w, h) {
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#333" offset="20%" />\n      <stop stop-color="#222" offset="50%" />\n      <stop stop-color="#333" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#333" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var blurDataUrl = function(w, h) {
    return "data:image/svg+xml;base64,".concat(toBase64(shimmer(w, h)));
};
/* harmony default export */ __webpack_exports__["ZP"] = (blurDataUrl);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [379,88,655,675,453,435,237,774,888,377], function() { return __webpack_exec__(37476); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);